var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadcrumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.691606 9.7505C0.39577 9.46058 0.390974 8.98573 0.680894 8.6899L3.95111 5.35294C4.03318 5.27032 4.03322 5.22074 4.03322 5.21484C4.03322 5.20895 4.03319 5.15935 3.95112 5.07673L3.94755 5.07314L0.680894 1.73979C0.390974 1.44395 0.39577 0.969105 0.691607 0.679184C0.987443 0.389264 1.46229 0.39406 1.75221 0.689897L5.01734 4.02165C5.3341 4.34144 5.53323 4.75639 5.53323 5.21484C5.53323 5.67331 5.33409 6.08826 5.01732 6.40806L1.75221 9.73979C1.46229 10.0356 0.987442 10.0404 0.691606 9.7505Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumIcon);
export default __webpack_public_path__ + "static/media/breadcrum_icon.20e0c85d76d70fcd172b08a28936ce6b.svg";
export { ForwardRef as ReactComponent };